import { Component, Directive, ElementRef, Injector, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'announcements-list-directive',
    standalone: false,
})
export class AnnouncementsListDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('announcements', elementRef, injector);
        console.log("AnnouncementsListDirective initialized");
    }
}

@Component({
    selector: 'announcements-list',
    template: '<announcements-list-directive></announcements-list-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnnouncementsListComponent {
    constructor() {
        console.log("AnnouncementsListComponent initialized");
    }
}

@Directive({
    selector: 'announcement-form-directive',
    standalone: false,
})
export class AnnouncementFormDirective extends UpgradeComponent {
    @Input() announcementId: string;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('announcement', elementRef, injector);
        console.log("AnnouncementFormDirective initialized");
    }
}

@Component({
    selector: 'announcement-form',
    template: '<announcement-form-directive [announcementId]="announcementId"></announcement-form-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnnouncementFormComponent implements OnInit {
    announcementId: string;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        // Subscribe to route params to get the announcement ID
        this.route.params.subscribe(params => {
            this.announcementId = params['id'] || null;
        });
    }
}

@Directive({
    selector: 'announcements-reorder-directive',
    standalone: false,
})
export class AnnouncementsReorderDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('announcementsReorder', elementRef, injector);
        console.log("AnnouncementsReorderDirective initialized");
    }
}

@Component({
    selector: 'announcements-reorder',
    template: '<announcements-reorder-directive></announcements-reorder-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnnouncementsReorderComponent {
    constructor() {
        console.log("AnnouncementsReorderComponent initialized");
    }
}

@Directive({
    selector: 'inbox-directive',
    standalone: false,
})
export class InboxDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('inboxComponent', elementRef, injector);
        console.log("InboxDirective initialized");
    }
}

@Component({
    selector: 'inbox',
    template: '<inbox-directive></inbox-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InboxComponent {
    constructor() {
        console.log("InboxComponent initialized");
    }
}

@Directive({
    selector: 'inbox-message-directive',
    standalone: false,
})
export class InboxMessageDirective extends UpgradeComponent {
    @Input() id: string;
    constructor(elementRef: ElementRef, injector: Injector) {
        super('inboxMessageComponent', elementRef, injector);
        console.log("InboxMessageDirective initialized");
    }
}

@Component({
    selector: 'inbox-message',
    template: '<inbox-message-directive [id]="id"></inbox-message-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InboxMessageComponent {
    @Input() id: string;
    constructor() {
        console.log("InboxMessageComponent initialized");
    }
}


